
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import { BarcodeOrderListItem } from "@/models/api/barcodeSystem/barcodeOrders/get";
import { formatDateWithTime, formatBool } from "@/utils";
import permissions from "@/security/permissions";

const inventoryModuleState = getModule(InventoryModule);
const barcodeOrderModuleState = getModule(BarcodeOrderModule);

@Component
export default class PalletOrderTable extends Vue {
  @Prop({ default: false })
  loading: boolean;

  get palletOrders(): Array<BarcodeOrderListItem> {
    return inventoryModuleState.palletOrdersData;
  }

  get selectedItemCount(): number {
    return inventoryModuleState.getSelectedPalletOrderCount;
  }

  get selectedItems(): Array<any> {
    return inventoryModuleState.getSelectedPalletOrders;
  }

  get totalItems() {
    if (inventoryModuleState.palletOrdersData) {
      return inventoryModuleState.palletOrdersData.length
    } else {
      return 0;
    }
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val)
  {
    return formatDateWithTime(val)
  }

  formatBool(val)
  {
    return formatBool(val);
  }

  onDoubleClicked(data) {
    if(this.hasPermission(permissions.barcodeSystem.orders.view))
      barcodeOrderModuleState.viewBarcodeOrderShortcutAction({selectedItems: [data]});
  }

  onRowClick(data) {
    this.unselectAll();
    inventoryModuleState.switchPalletOrderSelectionStatus(data.id);
  }

  unselectAll() {
    let items = this.selectedItems;

    items.forEach(item => {
      inventoryModuleState.switchPalletOrderSelectionStatus(item.id);
    });
  }
}
